/* BaseActivityViewColumnComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const _ = require("lodash");

class BaseActivityViewColumnComponent extends DefaultColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _normalizeCreateActivity(activityEntity) {
        let activity = {};
        _.set(activity, "activityType.activityType", "note");
        _.set(
            activity,
            "description.description",
            `Schedule created by user (${activityEntity.createdBy}).`
        );
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeUpdateActivity(activityEntity) {
        let patch = activityEntity.getProperty("patch");
        if (!patch) {
            return;
        }
        let description;
        let updatedBy = _.get(
            _.find(patch, {path: "/updatedBy"}),
            "value",
            _.get(activityEntity, "before.updatedBy", "system")
        );
        let activityType = updatedBy ? "note" : "system";
        let activityStatus = "clean";

        let status = _.get(_.find(patch, {path: "/status"}), "value");
        switch (status) {
            case "ACTIVE":
                description = `Schedule resumed by user (${updatedBy}).`;
                activityStatus = "resumed";
                break;
            case "PAUSED":
                description = `Schedule paused by user (${updatedBy}).`;
                activityStatus = "paused";
                break;
            case "COMPLETED":
                description = `Schedule completed.`;
                activityStatus = "completed";
                break;
            default:
                description = `Schedule updated by user (${updatedBy}).`;
                break;
        }

        let nextExecTime = _.get(_.find(patch, {path: "/nextExecutionTime"}), "value");
        if (nextExecTime) {
            activityType = "system";
            description = `Next execution time set to ${new Date(
                nextExecTime
            ).toLocaleTimeString()}.`;
        }

        if (description) {
            let activity = {};
            _.set(activity, "activityType.activityType", activityType);
            _.set(activity, "description.description", description);
            _.set(activity, "status", activityStatus);
            return activity;
        }
    }

    _normalizeTriggerActivity(activityEntity) {
        let description;
        let status = activityEntity.getProperty("status");
        let expectedExecutionTime = activityEntity.getProperty("expectedExecutionTime");
        let workTypeName = activityEntity.getProperty("workTypeName");
        let activityType = "system";
        let activityStatus = "clean";
        switch (status) {
            case "STARTING":
                activityStatus = "started";
                let launchedBy = activityEntity.getProperty("launchedBy");
                if (
                    launchedBy &&
                    launchedBy !== "SCHEDULE" &&
                    launchedBy !== "SYSTEM" &&
                    launchedBy !== "GluwareScheduler"
                ) {
                    description = `The user (${launchedBy}) manually started the work named ${workTypeName}.`;
                    activityType = "note";
                } else {
                    description = `Started the work named ${workTypeName} scheduled for ${new Date(
                        expectedExecutionTime
                    ).toLocaleDateString()} ${new Date(
                        expectedExecutionTime
                    ).toLocaleTimeString()}.`;
                }
                break;
            case "SUCCESSFUL":
                activityStatus = "successful";
                let successCnt = activityEntity.getProperty("successCount");
                let failCnt = activityEntity.getProperty("failureCount");
                description = `Completed the work named ${workTypeName} with ${successCnt} successes and ${failCnt} failures`;
                break;
            case "FAILED":
                activityStatus = "failed";
                let errMsg = activityEntity.getProperty("errorMsg");
                description = _.isEmpty(errMsg)
                    ? `The work named ${workTypeName} failed.`
                    : `The work named ${workTypeName} failed: ${errMsg}`;
                break;
            case "SKIPPED":
                activityStatus = "skipped";
                description = `Skipped the work named ${workTypeName} scheduled for ${new Date(
                    expectedExecutionTime
                ).toLocaleDateString()} ${new Date(expectedExecutionTime).toLocaleTimeString()}`;
                break;
            case "MISSED":
                activityStatus = "missed";
                description = `Missed the work named ${workTypeName} scheduled for ${new Date(
                    expectedExecutionTime
                ).toLocaleDateString()} ${new Date(expectedExecutionTime).toLocaleTimeString()}`;
                break;
            case "OVERLAPPED":
                activityStatus = "overlapped";
                description = `The work named ${workTypeName} scheduled for ${new Date(
                    expectedExecutionTime
                ).toLocaleDateString()} ${new Date(
                    expectedExecutionTime
                ).toLocaleTimeString()} did not run because it was already running`;
                break;
            case "RUNNING":
                activityStatus = "running";
                description = `The work named ${workTypeName} scheduled for ${new Date(
                    expectedExecutionTime
                ).toLocaleDateString()} ${new Date(
                    expectedExecutionTime
                ).toLocaleTimeString()} is running`;
                break;
            case "QUEUED":
                activityStatus = "queued";
                description = `The work named ${workTypeName} scheduled for ${new Date(
                    expectedExecutionTime
                ).toLocaleDateString()} ${new Date(
                    expectedExecutionTime
                ).toLocaleTimeString()} is queued`;
                break;
        }
        if (description) {
            let activity = {};
            _.set(activity, "activityType.activityType", activityType);
            _.set(activity, "description.description", description);
            _.set(activity, "status", activityStatus);
            return activity;
        }
    }

    _normalizeActivity(activityEntity) {
        let activity;
        let activityType = activityEntity.getProperty("activityType");
        switch (activityType) {
            case "create":
                activity = this._normalizeCreateActivity(activityEntity);
                break;
            case "update":
                activity = this._normalizeUpdateActivity(activityEntity);
                break;
            case "trigger":
                activity = this._normalizeTriggerActivity(activityEntity);
                break;
        }
        if (!_.isEmpty(activity)) {
            let date =
                new Date(activityEntity.createdOn).toLocaleDateString() +
                " " +
                new Date(activityEntity.createdOn).toLocaleTimeString();
            _.set(activity, "snapshot.snapshot", date);
            _.set(activity, "id", activityEntity.id);
        }

        return activity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BaseActivityViewColumnComponent;
